var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3.29883C7.2933 3.42444 6.36113 3.79146 5.55 4.39981L3.35 6.04981C2.65753 6.56915 2.25 7.38422 2.25 8.24981V16.8788C2.25 19.0918 4.77641 20.355 6.54677 19.0272C7.06228 18.6406 7.64605 18.3911 8.25 18.2787V3.29883Z",
    fill: "#001F06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 18.2787C10.3539 18.3911 10.9377 18.6406 11.4532 19.0272L11.55 19.0998C12.3611 19.7081 13.2933 20.0752 14.25 20.2008V5.22096C13.6461 5.10852 13.0623 4.85902 12.5468 4.47239L12.45 4.39981C11.6389 3.79146 10.7067 3.42444 9.75 3.29883V18.2787Z",
    fill: "#001F06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.22096V20.2008C16.7067 20.0752 17.6389 19.7082 18.45 19.0998L20.65 17.4498C21.3425 16.9305 21.75 16.1154 21.75 15.2498V6.62077C21.75 4.40781 19.2236 3.14461 17.4532 4.47239C16.9377 4.85902 16.3539 5.10852 15.75 5.22096Z",
    fill: "#001F06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map_icon.f7ac7f659e03f70f8f93f4d4ffa74f47.svg";
export { ForwardRef as ReactComponent };